import SearchPrompt from './../../core/search';
import ValidateService from './../../../../service/validate';
import ErrorService from './../../../../service/error';
import { FORM_FIELD } from './../../core/abstract';
import mapStateToProps from './../../../../store/map/auth-token';
import mapDispatchToProps from './../../../../store/map/on-logout';
import { connect } from 'react-redux';
import { Header, AdminSearchLogsViewPrompt, PurgeLogs } from './view';
import theme from './../../../theme';

class _AdminSearchLogsPrompt extends SearchPrompt 
{
    constructor(parms)
    {
        super(parms, _AdminSearchLogsPrompt.getValidators());

        this.getFieldsModel = this.getFieldsModel.bind(this);
        this.onSearchResponse = this.onSearchResponse.bind(this);
        this.onSearchError = this.onSearchError.bind(this);
        this.onSendToServer = this.onSendToServer.bind(this);
        this.getServerRequest = this.getServerRequest.bind(this);
        this.getSearchResultUi = this.getSearchResultUi.bind(this);
        this.onAuthError = this.onAuthError.bind(this);
        this.onFatalError = this.onFatalError.bind(this);
        this.onNetworkOffline = this.onNetworkOffline.bind(this);
        this.getSearchResultsUi = this.getSearchResultsUi.bind(this);
        this.getNoResultsUi = this.getNoResultsUi.bind(this);
        this.onPurgeLogs = this.onPurgeLogs.bind(this);
        this.onPurgeLogsResponse = this.onPurgeLogsResponse.bind(this);
    }

    static getValidators()
    {
        return {
            searchText: {
                isValid: ValidateService.anyValue
            }
        };
    }

    onAuthError()
    {
        this.props.onLogout();
    }

    onFatalError()
    {
        this.props.onUpdateError(true, '');
    }

    onNetworkOffline()
    {
        this.props.onUpdateDeviceOnline(false);
    }

    getFieldsModel()
    {
        return {
            searchText: {
                name: 'Search Logs',
                error: 'Specify a value mentioned in a log record',
                value: '',
                visible: true,
                touched: false,
                type: FORM_FIELD.TEXT
            }
        };
    }

    onSearchResponse(response)
    {
        super.onSearchResponse(response, 'logs');
    }

    onSendToServer(request = undefined)
    {
        ErrorService.adminSearchLogs({
            request: request ? request : this.getServerRequest(),
            onResponse: this.onSearchResponse,
            onError: this.onSearchError,
            authToken: this.props.authToken,
            onAuthError: this.onAuthError,
            onFatalError: this.onFatalError,
            onNetworkOffline: this.onNetworkOffline
        });
    } 
    
    /* istanbul ignore next */
    onPurgeLogs()
    {
        ErrorService.adminPurgeLogs({
            onResponse: this.onPurgeLogsResponse,
            onError: this.onSearchError,
            authToken: this.props.authToken,
            onAuthError: this.onAuthError,
            onFatalError: this.onFatalError,
            onNetworkOffline: this.onNetworkOffline
        });
    }

    /* istanbul ignore next */
    onPurgeLogsResponse(response)
    {
        const mockResponse = {
            logs: {
                total: 0,
                perPage: 15,
                page: 0,
                list: []
            }
        };
        this.onSearchResponse(mockResponse, 'logs');
    }

    getServerRequest()
    {
        return {
            page: 0,
            searchText: this.state.searchText.value
        };
    }

    /* istanbul ignore next */
    onLoadSpecifiedPage(page)
    {
        this.setContactingServer(true);
        let request = this.getServerRequest();
        request.page = page;
        this.onSendToServer(request);
    }

    getNoResultsUi()
    {
        return (
            <div style={{
                ...theme.getGeneralTextStyle(theme)
            }}>
                <p>
                    No Logs Found.
                </p>
            </div>
        );
    }

    getSearchResultUi(aResult, index)
    {
        return <AdminSearchLogsViewPrompt logRecord={aResult} key={index} />
    }

    getSearchResultsUi()
    {
        return this.state.results.length < 1 ? this.getNoResultsUi() : 
            <div>
                {
                    this.state.results.length > 0 && 
                        <PurgeLogs
                            onPurgeLogs={this.onPurgeLogs}
                        />
                }
                <table>
                    <Header />
                    <tbody>
                        {  this.state.results.map((aResult, index) => this.getSearchResultUi(aResult, index)) }
                    </tbody>
                </table>
            </div>
    }
}

const AdminSearchLogsPrompt = connect(mapStateToProps, mapDispatchToProps)(_AdminSearchLogsPrompt);
export default AdminSearchLogsPrompt;
